module.exports = __webpack_public_path__ + "static/ibpyp@large-932024a725281ae9d4666729024041f6.jpg";